import axios from "axios";
import { ApprovePostRequest, CreatePost, CreateQuickAction, CreateRecognition, PostRequest, SaveDeletePostReaction, SavePostComment } from "../interfaces/post.interface";
import { store } from "../store";


const employeePortalRequest = axios.create({
    baseURL: process.env.REACT_APP_EMPLOYEE_PORTAL_API,
	headers: {
		'x-api-key': process.env.REACT_APP_EMPLOYEE_PORTAL_API_KEY,
	}
})

export const getPostsRequest = async ({postType, nextPageB64}: PostRequest) => {
	const authState = store.getState().auth.companyselected;
	const params = {
		createdById: authState?.Code,
		employeeCode: authState?.Code,
		postType,
		nextPageB64,
	};	
	const result = await employeePortalRequest.get( 
		"/post",
		{params, headers: {"user-token": authState?.Token}},
	)
		.then(r => r)
		.catch(e => e.response);
	return result
}

export const getUnApprovedPostsRequest = async ({postType, nextPageB64}: PostRequest) => {
	const authState = store.getState().auth.companyselected;
	const params = {
		createdById: authState?.Code,
		employeeCode: authState?.Code,
		postType,
		nextPageB64,
	};
	const result = await employeePortalRequest.get( 
		"/post/approve",
		{params, headers: {"user-token": authState?.Token}},
	)
		.then(r => r)
		.catch(e => e.response);
	console.log(result)
	return result
}

export const deletePostsRequest = async (postData: any) => {
	const authState = store.getState().auth.companyselected;
	const result = await employeePortalRequest.delete( 
		"/post",
		{
			data: {
				...postData,
				createdById: authState?.Code,
			},
			headers: {"user-token": authState?.Token},
		},
	)
		.then(r => r)
		.catch(e => e.response);
	return result
}

export const setPostsRequest = async (userToken: string, postData: CreatePost | CreateRecognition | CreateQuickAction
) => {
	console.log(postData)
	const authState = store.getState().auth.companyselected;
	const result = await employeePortalRequest.post( 
		"/post",
		{
			...postData,
			createdById: authState?.Code,
		},
		{headers: {"user-token": userToken}},
	)
		.then(r => r)
		.catch(e => e.response);
	return result
}

export const setPostsCommentRequest = async (userToken: string, postData: SavePostComment) => {
	
	const authState = store.getState().auth.companyselected;
	const result = await employeePortalRequest.post( 
		"/comment",
		{
			...postData,
			createdById: authState?.Code,
		},
		{headers: {"user-token": userToken}},
	)
		.then(r => r)
		.catch(e => e.response);
	return result
}

export const getPostsCommentRequest = async (postData: SavePostComment) => {
	const authState = store.getState().auth.companyselected;
	const params = {
		employeeCode: authState?.Code,
		createdById: authState?.Code,
	};	
	
	const result = await employeePortalRequest.get( 
		`/comment?orderTimestamp-ID=${postData["orderTimestamp-ID"]}`,
		{params, headers: {"user-token": authState?.Token}},
	)
		.then(r => r)
		.catch(e => e.response);
	return result
}

export const setPostsReactionRequest = async (userToken: string, postData: SaveDeletePostReaction) => {
	const authState = store.getState().auth.companyselected;
	
	const result = await employeePortalRequest.post( 
		"/reactions",
		{
			...postData,
			createdById: authState?.Code,
		},
		{headers: {"user-token": userToken}},
	)
		.then(r => r)
		.catch(e => e.response);
	return result
}

export const setApprovePostRequest = async (postData: ApprovePostRequest) => {
	const authState = store.getState().auth.companyselected;
	
	const result = await employeePortalRequest.post( 
		"/post/approve",
		{
			...postData,
			createdById: authState?.Code,
		},
		{headers: {"user-token": authState?.Token}},
	)
		.then(r => r)
		.catch(e => e.response);
	console.log(result)
	return result
}

export const getLastAppVersion = async () => {
	const params = {
		appName: 'collaboratorweb',
	};
	const result = await employeePortalRequest.get( 
		"/app-version",
		{params},
	)
		.then(r => r)
		.catch(e => e.response);
	console.log(result)
	return result
}